import React from "react";
import StatsCards from "../ui/StatsCards";
import SummaryTable from "../ui/SummaryTable";
import PageHeader from "../ui/PageHeader";
import "./SummaryLayout.css";

function SummaryLayout({
  title,
  headerContent,
  statsConfig,
  totals,
  statsLoading,
  formatter,
  tableProps,
  summary,
  extraContent,
  hasBackButton = false,
}) {
  return (
    <div className="summary-layout-container">
      <PageHeader title={title} hasBackButton={hasBackButton}>
        {headerContent}
      </PageHeader>

      {statsConfig && (
        <div className="summary-layout-stats-wrapper">
          <StatsCards
            config={statsConfig}
            totals={totals}
            loading={statsLoading}
            formatter={formatter}
          />
        </div>
      )}

      {extraContent}

      <SummaryTable {...tableProps} summary={summary} />
    </div>
  );
}

export default SummaryLayout;
